//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'an-tooltip',
  props: {
    tooltipText: {
      type: String,
      default: '',
    },
  },
};
